import { BasketOutlineIcon } from './BasketOutlineIcon';

/**
 * author: Google
 * id A9AC5A33-FD7D-49C8-9C5E-C41335F6E833
 * name basket-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-outline.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketOutlineIcon = BasketOutlineIcon;
export default ShoppingBasketOutlineIcon